var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1083,
    height: 998,
    viewBox: "0 0 1083 998",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1082.618 664.962c0-42.306-8.268-82.544-22.875-119.751-70.005 101.56-186.173 163.71-309.508 163.71H.17v25.219c0 144.831 118.512 263.205 263.206 263.205h486.86c182.866 0 332.383-149.517 332.383-332.383",
    fill: "#FF7317"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.743 545.21c-6.34-16.122-13.643-31.694-22.324-46.44-57.74 99.082-164.814 166.192-287.184 166.192H.17v43.96h750.066c123.335 0 239.503-62.15 309.508-163.711",
    fill: "#E35C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.419 498.77c28.663-49.057 45.2-105.695 45.2-166.19C1082.618 149.713 933.1.058 750.234.058h-486.86C118.68.059.169 118.57.169 263.402v69.177h750.066c122.37 0 229.444 67.11 287.184 166.192",
    fill: "#231ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.419 498.77c-57.74-99.08-164.814-166.19-287.184-166.19H.17v332.382h750.066c122.37 0 229.444-67.11 287.184-166.191",
    fill: "#1919B8"
  }))));
}
export default SvgAppIcon;